import Highcharts from "highcharts/es-modules/masters/highcharts.src.js";
import "highcharts/es-modules/masters/modules/accessibility.src.js";
// Not left to @highcharts/react's autoloading: once loaded, it patches every axis to read a pane that only charts created
// after it have, so charts already on the page would throw on their next update
import "highcharts/es-modules/masters/highcharts-more.src.js";

Highcharts.setOptions({ palette: { colorScheme: "light" } });

// Tooltip#refresh throws when called with no points
Highcharts.wrap(
  Highcharts.Tooltip.prototype,
  "refresh",
  function (
    this: Highcharts.Tooltip,
    proceed: Highcharts.Tooltip["refresh"],
    pointOrPoints: Highcharts.Point | Highcharts.Point[],
    mouseEvent?: Highcharts.PointerEventObject,
  ) {
    const firstPoint = Array.isArray(pointOrPoints) ? pointOrPoints[0] : pointOrPoints;
    if (!firstPoint) return;
    proceed.call(this, pointOrPoints, mouseEvent);
  },
);

// Highcharts' internal HTMLElement, which draws useHTML text
type HTMLText = {
  element?: HTMLElement;
  foreignObject?: Highcharts.SVGElement;
  cTT?: string;
  textPxLength?: number;
  updateTransform: () => void;
};
const htmlTexts = new WeakMap<Highcharts.SVGRenderer, Set<HTMLText>>();

// Since v13, useHTML text sits in a foreignObject inside the SVG. Give it the container's font size, as v12's HTML
// layer had (the SVG root is 1rem), and since Highcharts sizes the foreignObject once, let it overflow and re-measure
// it when web fonts arrive instead of clipping or ellipsizing.
Highcharts.wrap(
  Highcharts.SVGRenderer.prototype,
  "html",
  function (this: Highcharts.SVGRenderer, proceed: (...args: unknown[]) => HTMLText, ...args: unknown[]) {
    const text = proceed.apply(this, args);
    const container = this.box.parentElement;
    text.foreignObject?.css({ overflow: "visible", fontSize: container ? getComputedStyle(container).fontSize : "" });
    htmlTexts.set(this, (htmlTexts.get(this) ?? new Set()).add(text));
    return text;
  },
);
document.fonts.addEventListener("loadingdone", () => {
  for (const chart of Highcharts.charts) {
    const texts = (chart && htmlTexts.get(chart.renderer)) ?? new Set<HTMLText>();
    for (const text of texts) {
      if (!text.element) {
        texts.delete(text);
        continue;
      }
      text.textPxLength = undefined;
      text.cTT = undefined;
      text.updateTransform();
    }
  }
});
